import { render } from "./UserInfo.vue?vue&type=template&id=84b9e93e&scoped=true"
import script from "./UserInfo.vue?vue&type=script&lang=js"
export * from "./UserInfo.vue?vue&type=script&lang=js"

import "./UserInfo.vue?vue&type=style&index=0&id=84b9e93e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-84b9e93e"

export default script